export default __webpack_public_path__ + "static/media/CNo.50-2.d3e31a83.jpg";